$( document ).ready(function() {
   // faq script
    $(".faq_accordion").smk_Accordion({
		showIcon: true, //boolean
		animation: true, //boolean
		closeAble: true, //boolean
		slideSpeed: 200 //integer, miliseconds
	});
        
});